// Spinner.jsx
// Client: vmfive
// Version: 1.0.0

import './Spinner.css';

export default function Spinner({ className = '', ...rest }) {
  return <div className={`spinner ${className}`} role="status" aria-label="Loading" {...rest} />;
}
